import React, { useEffect, useState } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import defaultLogo from '../../images/logo.png'
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { guardarSiteConfig, obtenerLogoGuardado, obtenerNombreTiendaGuardado } from '../siteConfig';
export default function Footer() {
    const [contactos, setContactos] = useState(null);
    const [contactoFooter, setContactoFooter] = useState(null);
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);
    const [storeName, setStoreName] = useState(() => obtenerNombreTiendaGuardado());
    const [storeCreatedYear, setStoreCreatedYear] = useState(() => new Date().getFullYear());

    useEffect(() => {
        cargarLogo();
    }, []);

    const cargarLogo = async () => {
        try {
            const response = await fetch(`${baseURL}/configGet.php`);
            const data = await response.json();
            if (data.config) {
                guardarSiteConfig(data.config);
            }
            if (data.config?.logo) {
                setAppLogo(data.config.logo);
            }
            setStoreName(data.config?.nombreTienda?.trim() || '');
            setStoreCreatedYear(data.config?.storeCreatedYear || new Date().getFullYear());
        } catch (error) {
            console.error('Error al cargar el logo:', error);
        }
    };

    useEffect(() => {
        cargarContacto();

    }, []);


    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const contactosOrdenados = Array.isArray(data.contacto) ? [...data.contacto].reverse() : [];
                const contactosVisibles = contactosOrdenados.filter((contacto) => String(contacto?.visibleFooter ?? '1') !== '0');
                setContactos(contactosOrdenados[0] || null);
                setContactoFooter(contactosVisibles[0] || null);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const instagramLink = contactos?.instagram
        ? (contactos.instagram.startsWith('http') ? contactos.instagram : `https://instagram.com/${contactos.instagram.replace('@', '')}`)
        : 'https://www.instagram.com/';
    const whatsappLink = contactos?.telefono
        ? `https://wa.me/${contactos.telefono.replace(/\D/g, '')}`
        : 'https://wa.me/';
    const facebookLink = contactos?.facebook
        ? (contactos.facebook.startsWith('http') ? contactos.facebook : `https://facebook.com/${contactos.facebook}`)
        : 'https://www.facebook.com/';

    const socialIcons = {
        whatsapp: (
            <svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>
                <path className='socialIconFill' d='M12 3.25a8.35 8.35 0 0 0-7.1 12.75l-.95 3.52 3.65-.92A8.35 8.35 0 1 0 12 3.25Z' />
                <path className='socialIconCutout' d='M9.18 7.7c-.18-.4-.36-.4-.52-.4h-.44c-.15 0-.4.06-.62.3-.21.23-.8.78-.8 1.9 0 1.11.82 2.18.93 2.33.11.16 1.58 2.53 3.92 3.44 1.94.76 2.34.61 2.76.57.42-.04 1.35-.55 1.54-1.08.19-.53.19-.99.13-1.08-.05-.09-.21-.15-.44-.27-.23-.11-1.35-.66-1.56-.74-.21-.08-.36-.11-.52.11-.15.23-.6.74-.74.89-.13.15-.27.17-.5.06-.23-.11-.96-.35-1.82-1.12-.67-.6-1.13-1.34-1.26-1.57-.13-.23-.01-.35.1-.46.1-.1.23-.27.34-.4.11-.14.15-.23.23-.38.08-.15.04-.29-.02-.4-.06-.11-.51-1.23-.71-1.7Z' />
            </svg>
        ),
        instagram: (
            <svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>
                <rect x='5' y='5' width='14' height='14' rx='4.2' />
                <circle cx='12' cy='12' r='3.2' />
                <circle cx='16.2' cy='7.8' r='1' />
            </svg>
        ),
        facebook: (
            <svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>
                <path className='socialIconFill' d='M14 8.1h2.1V4.8c-.36-.05-1.6-.15-3.05-.15-3.01 0-5.08 1.84-5.08 5.2v2.93H4.7v3.7h3.27v7.37h4.02v-7.37h3.15l.5-3.7H12v-2.56c0-1.07.29-1.8 2-1.8Z' />
            </svg>
        )
    };

    const renderSocialIcon = (href, iconKey, label) => (
        <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
            {socialIcons[iconKey]}
        </a>
    );


    return (
        <>
            <div className='FooterContain'>
                <div className='footerText'>
                    <Anchor to='' target="_blank">   <img src={appLogo} alt="logo" /></Anchor>
                    <h2>
                        {storeName || contactos?.nombre}
                    </h2>
                    <div className='socials'>
                        {renderSocialIcon(whatsappLink, 'whatsapp', 'WhatsApp')}
                        {renderSocialIcon(instagramLink, 'instagram', 'Instagram')}
                        {renderSocialIcon(facebookLink, 'facebook', 'Facebook')}
                    </div>
                </div>
                {contactoFooter && (
                    <div className='footerText'>
                        <h3>Contacto</h3>
                        {contactoFooter.email && <a href={`mailto:${contactoFooter.email}`} target="_blank" rel="noopener noreferrer">{contactoFooter.email}</a>}
                        {contactoFooter.telefono && <a href={`https://wa.me/${contactoFooter.telefono?.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer">{contactoFooter.telefono}</a>}
                        {contactoFooter.direccion && <a href={`https://www.google.com/maps?q=${encodeURIComponent(contactoFooter.direccion)}`} target="_blank" rel="noopener noreferrer">{contactoFooter.direccion}</a>}
                    </div>
                )}
                <div className='footerText'>
                    <h3>Ayuda</h3>
                    <Anchor to='/entregas'>Entregas</Anchor>
                    <Anchor to='/devoluciones'>Devoluciones</Anchor>
                    <Anchor to='/terminos-y-condiciones'>Términos y condiciones</Anchor>
                </div>
                <div className='footerText' style={{ display: 'none' }}>
                    <h3>Acceso</h3>
                    <Anchor to={`/dashboard`} className='btnAnch'>
                        <FontAwesomeIcon icon={faUser} /> Dashboard
                    </Anchor>
                </div>
            </div>
            <div className='Developer'>
                <p>{`© ${storeCreatedYear} ${storeName || contactos?.nombre || 'Tienda'} - Tu Catálogo`}</p>
            </div>
        </>
    )
}
